import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Component pages
import { DashboardComponent } from './client/dashboard/dashboard.component';
import { ClientUsersComponent } from './client/client-users/client-users.component';
import { QuestionnaireTemplatesComponent } from './management/questionnaire-templates/questionnaire-templates.component';
import { CreateQuestionnaireTemplateComponent } from './management/questionnaire-templates/create-questionnaire-template/create-questionnaire-template.component';
import { GeneralListsComponent } from './management/general-lists/general-lists.component';
import { QuestionnaireBaselinesComponent } from './management/questionnaire-baselines/questionnaire-baselines.component';
import { CreateQuestionnaireBaselineComponent } from './management/questionnaire-baselines/create-questionnaire-baseline/create-questionnaire-baseline.component';
import { ProjectConversationComponent } from './client/projects/project-content/project-conversation/project-conversation.component';
import { ProjectExamineeComponent } from './client/projects/project-content/project-examinee/project-examinee.component';
import { ApiKeysComponent } from './client/api-keys/api-keys.component';
import { ApiDocsComponent } from './client/api-docs/api-docs.component';
import { ResearchAdminsComponent } from './management/research-admins/research-admins.component';

const routes: Routes = [
	{ path: '', component: DashboardComponent },
	{ path: 'projects', loadChildren: () => import('./client/projects/projects.module').then(m => m.ProjectsModule) },
	{ path: 'clients', loadChildren: () => import('./management/clients/clients.module').then(m => m.ClientsModule) },
	{ path: 'api-keys', component: ApiKeysComponent },
	{ path: 'api-docs', component: ApiDocsComponent },
	{ path: 'conversations', component: ProjectConversationComponent },
	{ path: 'examinees', component: ProjectExamineeComponent },
	{ path: 'users', component: ClientUsersComponent },
	{ path: 'templates', component: QuestionnaireTemplatesComponent },
	{ path: 'templates/create', component: CreateQuestionnaireTemplateComponent },
	{ path: 'baselines', component: QuestionnaireBaselinesComponent },
	{ path: 'baselines/create', component: CreateQuestionnaireBaselineComponent },
	{ path: 'baselines/edit/:baseline_id', component: CreateQuestionnaireBaselineComponent },
	{ path: 'lists', component: GeneralListsComponent },
	{ path: 'research-admins', component: ResearchAdminsComponent },
	{ path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
